import React from "react";
import { UserRoleStrings } from "modules/authorization/models";
import TenantLink from "modules/common/components/tenantLink";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { UserRoleWrapper } from "./wrappers/UserRoleWrapper";
import { AccordionWrapper } from "./wrappers/AccordionWrapper";
import { useMenuStyles } from "../styles/menuItemStyles";
import { ListItemButton } from "@mui/material";

export enum MenuItemType {
    Divider,
    Link,
    Header,
    Button
}

export enum MenuItemLabel {
    EMPTY = "",
    HOME = "Home",
    FEED = "My Feed",
    EVENTS = "Events",
    PORTAL_PAGES = "Portal Pages",
    DOCUMENTS = "Documents",
    SHORTCUTS = "Shortcuts",
    PROFILE = "My Profile",
    ADMIN_PORTAL = "Go to Admin Portal",
    SIGN_IN = "Sign in",
    MORE = "More",
    DASHBOARD = "Dashboard",
    POSTS = "Posts",
    CONTENT_MANAGEMENT = "Content Management",
    SURVEYS = "Surveys",
    QUICK_LINKS = "QuickLinks",
    TARGETING_TOOLS = "Targeting Tools",
    AUDIENCES = "Audiences",
    TOPICS = "Topics (Posts & Events)",
    CATEGORY_TAGS = "Category Tags",
    MESSAGING_CENTER = "Messaging Center",
    DIRECT_MESSAGING =  "Direct Messaging",
    NEWSLETTERS = "Newsletters",
    MEDIA_GALLERY = "Media Gallery",
    ACTIVITY_TOOLS = "Activity Tools",
    PLATFORM_ANALYTICS = "Platform",
    USER_ANALYTICS = "Users",
    ANALYTICS = "Analytics",
    AUDIENCE_ANALYTICS = "Audiences",
    USER_PERMISSIONS =  "Users & Permissions",
    TENANT_CONFIGURATIONS = "Tenant Configurations",
    TENANT_MANAGEMENT = "Tenant Management",
    COMAPANY_PORTAL = "Go to Company Portal",
    HOME_SCREENS = "Home Screens",
    CHANNEL_LAYOUTS = "Channel Layouts",
    MANAGE_MY_CONTENT = "Manage my content",
    EMAILS = "Emails",
    SMS = "SMS Messaging"
}

export interface IMenuItem {
    children?: IMenuItem[];
    endIcon?: JSX.Element;
    hide?: boolean;
    icon?: JSX.Element;
    label: MenuItemLabel;
    pushToBrowserHistory?: boolean;
    type: MenuItemType;
    url?: string;
    userRole?: UserRoleStrings;
    userRoles?: UserRoleStrings[];
    strictRole?: boolean; // for restricting users who are ONLY a certain role instead of having a role via the hierarchy
    onButtonClick?: () => void;
    buttonItemSelected?: boolean; // for dictating if a button menu item is selected or not
}

export const MenuItem: React.FunctionComponent<ComponentProps> = props => {
    const { menuItem } = props;
    const classes = useMenuStyles();

    if (menuItem.hide)
        return <React.Fragment></React.Fragment>;

    return (
        <UserRoleWrapper userRole={menuItem.userRole} strictRole={menuItem.strictRole}>
            <AccordionWrapper {...props}>
                <div className={classes.menuItem}>
                    <TenantLink 
                        to={menuItem.url || ""} 
                        pushToBrowserHistory={menuItem.pushToBrowserHistory} 
                        onClick={() => props.onMenuItemClicked && props.onMenuItemClicked(menuItem)}
                    >
                        <ListItemButton
                            disableRipple
                            onClick={() => props.setExpandedMenuItem("")}
                            className={`${classes.listItem} ${props.selected ? "selected" : ""}`}
                        >
                            {!props.hideIcons &&
                                <ListItemIcon title={menuItem.label} className={classes.listItemIcon}>
                                    {menuItem.icon}
                                </ListItemIcon>
                            }
                            <div className={`${classes.expandableText} ${props.expand ? "expanded" : ""}`}>
                                <ListItemText
                                    primary={menuItem.label} classes={{ primary: classes.listItemText }} />
                                {menuItem.endIcon}
                            </div>
                        </ListItemButton>
                    </TenantLink>
                </div>
            </AccordionWrapper>
        </UserRoleWrapper>
    );
};

interface ComponentProps {
    expand?: boolean;
    expandedMenuItem: string;
    hideIcons?: boolean;
    menuItem: IMenuItem;
    selected?: boolean;
    toggleExpand: () => void;
    setExpandedMenuItem: (menuItem: string) => void;
    onMenuItemClicked?: (menuItem: IMenuItem) => void;
}
